import { Flex, Spinner } from "@chakra-ui/react";
import { Icon } from "assets/Icon";
import Tooltip from "components/Tooltip";
import { Button } from "newui/components/Button";

interface ContinueButtonProps {
	disabled: boolean;
	isSubmittingForm?: boolean;
	isTemplate?: boolean;
	isValidating?: boolean;
	lastStep: boolean;
	showIgnoreApproversButton: boolean;
	onClick: () => void;
}

const ContinueButton = ({
	onClick,
	disabled,
	lastStep,
	isSubmittingForm,
	isValidating,
	isTemplate,
	showIgnoreApproversButton,
}: ContinueButtonProps) => {
	return (
		<Tooltip
			label={
				disabled &&
				lastStep &&
				`You cannot ${isTemplate ? "save this template" : "send this RFx"} yet - please check all tabs have been completed correctly.`
			}
		>
			<Button
				disabled={disabled}
				btntype={"primary"}
				type="button"
				onClick={onClick}
			>
				{showIgnoreApproversButton && lastStep ? (
					<Flex
						gap={2}
						align={"center"}
					>
						{"Awaiting Approval - Click to Override and Send Rfx"}
						<Icon
							iconClassName={
								disabled ? "text-bg-gray-200" : "text-bg-brand-solid"
							}
							icon={"check-circle"}
						/>
					</Flex>
				) : isSubmittingForm || isValidating ? (
					<Spinner />
				) : lastStep ? (
					isTemplate ? (
						"Save Template"
					) : (
						"Send RFx"
					)
				) : (
					"Continue"
				)}
			</Button>
		</Tooltip>
	);
};

export default ContinueButton;
